"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LArtDeVivreEnUzege() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222221" id="legacy-value-hero" className="relative w-full h-[100dvh] min-h-[600px] flex flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/40 to-transparent z-10" />
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/luxury_boardroom_ocean_sunset.png)] scale-105 transition-transform duration-[20000ms] ease-linear hover:scale-100" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 flex flex-col items-center text-center px-4 md:px-8 transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="font-default text-6xl md:text-8xl lg:text-[72px] leading-none text-white font-bold tracking-tighter">
          Unlock Maximum Value for Your Business Legacy
        </h2>
        {}
        <span className="font-default text-4xl md:text-6xl text-secondary-foreground mt-2 md:mt-4 ml-24 md:ml-48 transform -rotate-2 border-b-4 border-primary-foreground/60">
          Expert M&A Advisory
        </span>
      </div>

      {}
      <div className="absolute bottom-16 md:bottom-24 z-20 flex flex-col items-center animate-bounce">
        <Link to="/AdvisoryServicesPage">
          <Button size="lg" className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 rounded-md px-10 py-7 text-lg shadow-3xl shadow-primary/20 transition-all hover:scale-105 hover:shadow-4xl hover:shadow-primary/40 font-mono uppercase tracking-widest">
            Schedule Confidential Advisory
          </Button>
        </Link>
      </div>
    </section>;
}